import { PermissionType } from '../../../context/PermissionsContext';

const DEFAULT_GLOBAL_PERMISSIONS = {
  active: false,
  admin: false,
  export: false,
  financials: false,
  edit: false,
  approver: false,
};

const ROLES_DATA = [
  { uuid: 'corporate', name: 'Corporate' },
  { uuid: 'division', name: 'Division' },
  { uuid: 'location', name: 'Location' },
];

const USER_TYPES = {
  CORPORATE: 'Corporate',
  DIVISION: 'Division',
  LOCATION: 'Location',
};

type PermissionKey =
  | 'ACTIVE'
  | 'ADMIN'
  | 'EXPORT'
  | 'FINANCIALS'
  | 'EDIT'
  | 'APPROVER';

const GENERAL_PERMISSIONS: Record<PermissionKey, PermissionType> = {
  ACTIVE: 'active',
  ADMIN: 'admin',
  EXPORT: 'export',
  FINANCIALS: 'financials',
  EDIT: 'edit',
  APPROVER: 'approver',
} as const;

const PERMISSIONS_TOGGLES = [
  { key: 'active', label: 'Active' },
  { key: 'admin', label: 'Admin' },
  { key: 'export', label: 'Export' },
  { key: 'financials', label: 'Financials' },
  { key: 'edit', label: 'Edit' },
  { key: 'approver', label: 'Approver' },
];

const USER_PERMISSIONS_ERRORS = {
  ACTIVE_PERMISSIONS: 'You cannot remove your own active permissions',
  ACTIVE_PERMISSIONS_BULK:
    'You cannot remove your own active permissions in bulk',
  ADMIN_PERMISSIONS: 'You cannot remove your own admin permissions',
  ADMIN_PERMISSIONS_BULK:
    'You cannot remove your own admin permissions in bulk',
  CORPORATE_PERMISSIONS: 'Only corporate users can have admin permissions',
  SELECT_USER_TYPE: 'Select a user type first',
  SELECT_DIVISION: 'Please select at least one division(s)',
  SELECT_LOCATION: 'Please select at least one location(s)',
};

export {
  DEFAULT_GLOBAL_PERMISSIONS,
  ROLES_DATA,
  PERMISSIONS_TOGGLES,
  USER_TYPES,
  GENERAL_PERMISSIONS,
  USER_PERMISSIONS_ERRORS,
};
